


















































































import flightProvider from "@/store/entities/flight/flightProvider";
import { Component, Vue } from "vue-property-decorator";
import AddProvider from "./modals/addProvider.vue";

@Component({
  components: { AddProvider },
})
export default class Providers extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  flightProviders: flightProvider[] = [];

  created() {
    this.getFlightProviders();

    (this.headers = [
      { text: "Tedarikçi Adı", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      // this.mockData=[
      //   {
      //     name:'CHARTERSCANNERS',
      //   },

      // ]

      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Tanımlamalar", disabled: true },
        { text: "Tedarikçiler", disabled: true },
      ]);
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getFlightProviders() {
    await this.$store.dispatch({
      type: "flightProvider/getFlightProviders",
    });

    this.flightProviders = this.$store.state.flightProvider.list;
  }

  editFlightProvider(item) {
    this.$store.state.flightProvider.editFlightProvider = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.flightProvider.editFlightProvider = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getFlightProviders();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
